<template>
  <v-sheet :min-height="this.$root.windowHeight">
    <v-container class="fill-height">
      <v-col align="center">
        <v-row justify="center" align="center" class="mt-12 mb-12">
          <h1>
            Te dejamos tu {{ $route.params['year'] }} en {{records.length}} películas 😉
          </h1>
        </v-row>
        <MovieWall :records="records"/>
      </v-col>
    </v-container>
  </v-sheet>
</template>
<script>
import MovieWall from "@/components/MovieWall";
export default {
  name: "HistoryWrapper",
  components: {MovieWall},
  props: ['records']
}
</script>

<style scoped>

</style>
